<script setup lang="ts">
import type { PropType } from 'vue';

defineProps({
  text: { type: String as PropType<string>, default: '' },
  testId: { type: String as PropType<string>, default: '' }
});
</script>
<template>
  <p :class="'my-1 font-ubuntu text-xs font-normal leading-4 text-left text-error'" :data-testid="testId">
    {{ text }}
  </p>
</template>
